module.exports = __webpack_public_path__ + "static/ecomonkeytoy-afefe74124b60b853fc6591d2c85efd6.jpeg";